/** Monta o path `/payment?…` após atualizar a cotação na personalização. */
export function buildPaymentQuoteUrl(
  args: Readonly<{
    quoteHash: string;
    plan: string | null;
    distribuitor: string | null;
    org: string | null;
    seller: string | null;
    channel?: string | null;
  }>
): string {
  const { quoteHash, plan, distribuitor, org, seller, channel } = args;
  const queryTail = `${plan ? `&plan=${plan}` : ''}${distribuitor ? `&dis=${distribuitor}` : ''}${
    org ? `&org=${org}` : ''
  }${seller ? `&seller=${seller}` : ''}${channel ? `&channel=${channel}` : ''}`;
  return `/payment/?quote=${quoteHash}${queryTail}`;
}
